/* ===== Pro Sticky ATC - section-scoped bundle/native sync ===== */
(function () {
  if (window.PawlishStickyAtc && typeof window.PawlishStickyAtc.refresh === 'function') {
    window.PawlishStickyAtc.refresh();
    return;
  }

  var instances = new WeakMap();

  function getText(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function normalizeOptionText(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text || text === 'Default Title') return '';

    return text.replace(/(\d)\s*[xX]\s*(\d)/g, '$1×$2');
  }

  function pushUniqueOption(values, seen, value) {
    var text = normalizeOptionText(value);
    var key = text.toLocaleLowerCase();

    if (!text || seen[key]) return;

    seen[key] = true;
    values.push(text);
  }

  function getImageData(image) {
    if (!image) return null;

    var src = image.currentSrc || image.src || '';
    if (!src) return null;

    return {
      src: src,
      alt: image.alt || '',
    };
  }

  function parseBackgroundImage(value) {
    var match = String(value || '').match(/url\(\s*(['"]?)(.*?)\1\s*\)/i);
    return match && match[2] ? match[2] : '';
  }

  function getSelectedVariantData(root, sectionId) {
    if (!root) return null;

    var variantRoot =
      root.querySelector('[id="variant-selects-' + sectionId + '"]') ||
      root.querySelector('variant-selects') ||
      root.querySelector('variant-radios');
    var script = variantRoot ? variantRoot.querySelector('[data-selected-variant]') : null;

    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantFeaturedImage(variant) {
    if (!variant) return null;

    var media = variant.featured_media || variant.featured_image;
    if (!media) return null;

    var image = media.preview_image || media;
    var src = typeof image === 'string' ? image : image.src || image.url || '';

    if (!src && typeof media !== 'string') src = media.src || media.url || '';
    if (!src) return null;

    return {
      src: src,
      alt: (typeof media !== 'string' && media.alt) || (typeof image !== 'string' && image.alt) || variant.title || '',
    };
  }

  function getSelectedOptionImage(sectionId, root) {
    if (!root) return null;

    var variantRoot =
      root.querySelector('[id="variant-selects-' + sectionId + '"]') ||
      root.querySelector('variant-selects') ||
      root.querySelector('variant-radios');

    if (!variantRoot) return null;

    var colorGroup = variantRoot.querySelector('.product-form__input--pro-color');

    if (!colorGroup) {
      colorGroup = Array.from(variantRoot.querySelectorAll('.product-form__input')).find(function (group) {
        var selectedControl = group.querySelector('input:checked, select');
        var optionName = selectedControl && selectedControl.dataset ? selectedControl.dataset.optionName : '';
        return /colou?r/i.test(optionName || '');
      });
    }

    if (!colorGroup) return null;

    var checkedInput = colorGroup.querySelector('input[type="radio"]:checked');

    if (checkedInput) {
      var label = Array.from(colorGroup.querySelectorAll('label')).find(function (candidate) {
        return candidate.htmlFor === checkedInput.id;
      });
      var image = label ? label.querySelector('img') : null;
      var imageData = getImageData(image);

      if (imageData) return imageData;

      var swatch = label ? label.querySelector('.swatch') : null;
      if (swatch) {
        var background = swatch.style.getPropertyValue('--swatch--background');
        if (!background && window.getComputedStyle) {
          background = window.getComputedStyle(swatch).getPropertyValue('--swatch--background');
        }

        var swatchSrc = parseBackgroundImage(background);
        if (swatchSrc) return { src: swatchSrc, alt: checkedInput.value || '' };
      }
    }

    var select = colorGroup.querySelector('select');
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var optionSwatch = option && option.dataset ? option.dataset.optionSwatchValue : '';
    var optionSrc = parseBackgroundImage(optionSwatch);

    return optionSrc ? { src: optionSrc, alt: option.value || '' } : null;
  }

  function getQuantity(value) {
    var quantity = parseInt(value || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getOptionalQuantity(value) {
    var quantity = parseInt(value || '', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : null;
  }

  function getProductRoot(bar, sectionId) {
    return (
      (bar && bar.closest('product-info[data-section]')) ||
      document.getElementById('MainProduct-' + sectionId) ||
      Array.from(document.querySelectorAll('product-info[data-section]')).find(function (root) {
        return root.dataset.section === String(sectionId);
      }) ||
      null
    );
  }

  function getSelectedBundleCard(root) {
    if (!root) return null;
    var checked =
      root.querySelector('[data-pro-bundle-root] .bqu-radio:checked') || root.querySelector('.bqu-radio:checked');
    return checked ? checked.closest('.bqu-card') : null;
  }

  function getSelectedBundleInfo(root) {
    var card = getSelectedBundleCard(root);
    if (!card) return null;

    var bundleRoot = card.closest('[data-pro-bundle-root]');

    if (!bundleRoot) {
      var bundleList = card.closest('.bqu-list');
      bundleRoot = bundleList ? bundleList.parentElement : null;
    }

    var proxyButton = bundleRoot
      ? bundleRoot.querySelector('[data-pro-bundle-proxy], .bqu-btn--proxy[id^="bqu-btn-"]')
      : null;
    if (!bundleRoot || !proxyButton) return null;

    var title = getText(card.querySelector('.bqu-name'));
    var subtitle = getText(card.querySelector('.bqu-sub'));
    var price = getText(card.querySelector('.bqu-now'));
    var image = card.querySelector('.bqu-img');
    var checkedRadio = card.querySelector('.bqu-radio');
    var bundleQuantity = checkedRadio ? getQuantity(checkedRadio.value) : 1;
    var selectedOptions = [];
    var bundleVariantSelects = card.querySelectorAll('.bqu-unit-variant-select, .bqu-variant-select');

    bundleVariantSelects.forEach(function (select) {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      var text = option.textContent.replace('- Sold out', '').replace(/\s+/g, ' ').trim();
      if (text && text !== 'Default Title') selectedOptions.push(text);
    });

    var optionSummary = '';

    if (selectedOptions.length) {
      var grouped = {};

      selectedOptions.forEach(function (optionText) {
        grouped[optionText] = (grouped[optionText] || 0) + 1;
      });

      optionSummary = Object.keys(grouped)
        .map(function (optionText) {
          return grouped[optionText] > 1 ? optionText + ' x' + grouped[optionText] : optionText;
        })
        .join(' + ');
    }

    return {
      root: bundleRoot,
      card: card,
      title: title,
      subtitle: subtitle,
      price: price,
      image: image ? image.currentSrc || image.src : '',
      imageAlt: image ? image.alt || '' : '',
      optionSummary: optionSummary,
      quantity: bundleQuantity,
      hasVariantSelectors: bundleVariantSelects.length > 0,
      button: proxyButton,
    };
  }

  function getNativeVariantText(sectionId, root) {
    if (!root) return '';

    var values = [];
    var seen = {};
    var variantRoot =
      root.querySelector('[id="variant-selects-' + sectionId + '"]') ||
      root.querySelector('variant-selects') ||
      root.querySelector('variant-radios');

    if (!variantRoot) return '';

    var groups = variantRoot.querySelectorAll('.product-form__input');

    groups.forEach(function (group) {
      var selectedValue = group.querySelector('[data-selected-value]');
      var text = selectedValue ? getText(selectedValue) : '';

      if (!text) {
        var select = group.querySelector('select');
        var option = select && select.options ? select.options[select.selectedIndex] : null;
        if (option) text = option.value || option.text || '';
      }

      if (!text) {
        var checkedInput = group.querySelector('input[type="radio"]:checked');
        if (checkedInput) text = checkedInput.value || '';
      }

      pushUniqueOption(values, seen, text);
    });

    if (!values.length) {
      variantRoot.querySelectorAll('[data-selected-value]').forEach(function (element) {
        pushUniqueOption(values, seen, getText(element));
      });
    }

    if (!values.length) {
      variantRoot.querySelectorAll('select').forEach(function (select) {
        var option = select.options ? select.options[select.selectedIndex] : null;
        if (option) pushUniqueOption(values, seen, option.value || option.text || '');
      });

      variantRoot.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        pushUniqueOption(values, seen, input.value || '');
      });
    }

    return values.join(' / ');
  }

  function getProductForm(root) {
    return root ? root.querySelector('form[data-pro-cart-coordinator-form]') : null;
  }

  function getNativeButton(root, sectionId) {
    if (!root) return null;
    return root.querySelector('[id="ProductSubmitButton-' + sectionId + '"]');
  }

  function getNativeQuantityInput(root) {
    var form = getProductForm(root);
    return form ? form.elements.namedItem('quantity') : null;
  }

  function getQuantityRules(input, fallback) {
    var fallbackRules = fallback || { min: 1, max: null, step: 1 };
    var min = input ? getOptionalQuantity(input.getAttribute('min')) : null;
    var max = input ? getOptionalQuantity(input.getAttribute('max')) : null;
    var step = input ? getOptionalQuantity(input.getAttribute('step')) : null;

    min = min || getQuantity(fallbackRules.min);
    step = step || getQuantity(fallbackRules.step);

    if (max === null && fallbackRules.max !== undefined) {
      max = getOptionalQuantity(fallbackRules.max);
    }

    if (max !== null && max < min) max = min;

    return {
      min: min,
      max: max,
      step: step,
    };
  }

  function getAlignedMaximum(rules) {
    if (!rules || rules.max === null) return null;
    return rules.min + Math.floor((rules.max - rules.min) / rules.step) * rules.step;
  }

  function normalizeQuantity(value, rules, direction) {
    var normalizedRules = getQuantityRules(null, rules);
    var quantity = getQuantity(value);
    var max = getAlignedMaximum(normalizedRules);

    quantity = Math.max(normalizedRules.min, quantity);
    if (max !== null) quantity = Math.min(max, quantity);

    var offset = quantity - normalizedRules.min;
    var remainder = offset % normalizedRules.step;

    if (remainder !== 0) {
      if (direction === 'down') {
        quantity -= remainder;
      } else if (direction === 'up') {
        quantity += normalizedRules.step - remainder;
      } else {
        quantity = normalizedRules.min + Math.round(offset / normalizedRules.step) * normalizedRules.step;
      }
    }

    quantity = Math.max(normalizedRules.min, quantity);
    if (max !== null) quantity = Math.min(max, quantity);
    return quantity;
  }

  function setNativeQuantity(root, quantity, rules, direction) {
    var form = getProductForm(root);
    if (!form) return normalizeQuantity(quantity, rules, direction);

    var input = form.elements.namedItem('quantity');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.min = String(rules.min);
      input.step = String(rules.step);
      if (rules.max !== null) input.max = String(rules.max);
      form.appendChild(input);
    }

    var effectiveRules = getQuantityRules(input, rules);
    var normalized = normalizeQuantity(quantity, effectiveRules, direction);
    var changed = String(input.value) !== String(normalized);

    input.value = String(normalized);

    if (changed) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return normalized;
  }

  function getSourceStickyState(html, sectionId) {
    if (!html || !html.querySelectorAll) return null;

    var sourceBar = Array.from(html.querySelectorAll('[data-pro-sticky-atc]')).find(function (candidate) {
      return String(candidate.dataset.sectionId || '') === String(sectionId);
    });

    if (!sourceBar) return null;

    var sourceImage = sourceBar.querySelector('[data-pro-sticky-atc-image]');
    var sourceQuantity = sourceBar.querySelector('[data-pro-sticky-atc-qty]');

    return {
      image: sourceImage
        ? {
            src: sourceImage.currentSrc || sourceImage.src || '',
            alt: sourceImage.alt || '',
          }
        : null,
      rules: sourceQuantity ? getQuantityRules(sourceQuantity) : null,
    };
  }

  function updateBodyVisibilityClass() {
    document.body.classList.toggle(
      'pro-sticky-atc-is-visible',
      Boolean(document.querySelector('[data-pro-sticky-atc].is-visible'))
    );
  }

  function getStickyBars(scope) {
    var bars = [];
    var root = scope && scope.querySelectorAll ? scope : document;

    if (root.matches && root.matches('[data-pro-sticky-atc]')) bars.push(root);

    root.querySelectorAll('[data-pro-sticky-atc]').forEach(function (bar) {
      bars.push(bar);
    });

    return bars;
  }

  function destroyStickyBar(bar) {
    var instance = instances.get(bar);
    if (!instance) return;

    instance.destroy();
    instances.delete(bar);
    bar.removeAttribute('data-pro-sticky-scoped-init');
  }

  function destroyWithin(scope) {
    getStickyBars(scope).forEach(destroyStickyBar);
    window.requestAnimationFrame(updateBodyVisibilityClass);
  }

  function initStickyBar(bar) {
    if (instances.has(bar)) return;

    var sectionId = bar.dataset.sectionId;
    var productRoot = getProductRoot(bar, sectionId);
    if (!productRoot) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var unsubscribeVariant = null;
    var unsubscribeQuantity = null;
    var visibilityObserver = null;
    var visibilitySentinel = null;
    var legacyVisibilityHandler = null;
    var showAfter = parseInt(bar.dataset.showAfter || '320', 10);
    var stickyButton = bar.querySelector('[data-pro-sticky-atc-submit]');
    var stickyTitle = bar.querySelector('.pro-sticky-atc__title');
    var stickyVariant = bar.querySelector('[data-pro-sticky-atc-variant]');
    var stickyPrice = bar.querySelector('[data-pro-sticky-atc-price]');
    var stickyImage = bar.querySelector('[data-pro-sticky-atc-image]');
    var stickyQuantity = bar.querySelector('[data-pro-sticky-atc-qty]');
    var stickyQuantityWrap = bar.querySelector('[data-pro-sticky-atc-qty-wrap]');
    var stickyMinus = bar.querySelector('[data-pro-sticky-atc-minus]');
    var stickyPlus = bar.querySelector('[data-pro-sticky-atc-plus]');
    var originalTitle = stickyTitle ? stickyTitle.textContent : '';
    var nativeImage = stickyImage
      ? { src: stickyImage.currentSrc || stickyImage.src || '', alt: stickyImage.alt || '' }
      : null;
    var initialVariant = getSelectedVariantData(productRoot, sectionId);
    var imageSyncToken = 0;

    if (!getVariantFeaturedImage(initialVariant)) {
      nativeImage = getSelectedOptionImage(sectionId, productRoot) || nativeImage;
    }

    var nativeRules = stickyQuantity ? getQuantityRules(stickyQuantity) : { min: 1, max: null, step: 1 };
    var visibilityState = {
      passedThreshold: window.scrollY >= showAfter,
      primaryActionAbove: false,
      visible: false,
    };

    bar.dataset.proStickyScopedInit = 'true';

    function applyStickyImage(image) {
      if (!stickyImage || !image || !image.src) return;
      stickyImage.src = image.src;
      stickyImage.removeAttribute('srcset');
      if (image.alt) stickyImage.alt = image.alt;
    }

    function updateNativeImage(image, applyImmediately) {
      if (!image || !image.src) return false;

      nativeImage = image;

      if (applyImmediately && !getSelectedBundleInfo(productRoot)) {
        applyStickyImage(nativeImage);
      }

      return true;
    }

    function resyncNativeImageAfterVariant(expectedVariantId, token, remainingPasses) {
      window.requestAnimationFrame(function () {
        if (token !== imageSyncToken) return;

        var liveVariant = getSelectedVariantData(productRoot, sectionId);

        if (
          expectedVariantId &&
          liveVariant &&
          liveVariant.id &&
          String(liveVariant.id) !== String(expectedVariantId)
        ) {
          return;
        }

        updateNativeImage(
          getVariantFeaturedImage(liveVariant) || getSelectedOptionImage(sectionId, productRoot),
          true
        );
        syncSticky();

        if (remainingPasses > 1) {
          resyncNativeImageAfterVariant(expectedVariantId, token, remainingPasses - 1);
        }
      });
    }

    function setStickyQuantityLocked(isLocked) {
      if (stickyQuantityWrap) stickyQuantityWrap.classList.toggle('is-bundle-locked', isLocked);
      if (stickyQuantity) stickyQuantity.readOnly = isLocked;

      if (isLocked) {
        if (stickyMinus) stickyMinus.disabled = true;
        if (stickyPlus) stickyPlus.disabled = true;
      }
    }

    function syncStickyQuantity(value, rules, isLocked) {
      if (!stickyQuantity) return;

      var normalizedRules = getQuantityRules(null, rules);
      var normalizedValue = normalizeQuantity(value, normalizedRules);
      var max = getAlignedMaximum(normalizedRules);

      stickyQuantity.min = String(normalizedRules.min);
      stickyQuantity.step = String(normalizedRules.step);

      if (max !== null) stickyQuantity.max = String(max);
      else stickyQuantity.removeAttribute('max');

      stickyQuantity.value = String(normalizedValue);
      setStickyQuantityLocked(isLocked);

      if (!isLocked) {
        if (stickyMinus) stickyMinus.disabled = normalizedValue <= normalizedRules.min;
        if (stickyPlus) stickyPlus.disabled = max !== null && normalizedValue >= max;
      }
    }

    function syncFromBundle(bundle) {
      if (stickyTitle && bundle.title) stickyTitle.textContent = bundle.title;

      if (stickyVariant) {
        var metadata = bundle.optionSummary || '';
        if (bundle.subtitle) metadata = metadata ? metadata + ' • ' + bundle.subtitle : bundle.subtitle;

        stickyVariant.classList.toggle('hidden', !metadata);
        stickyVariant.textContent = metadata;
      }

      if (stickyPrice && bundle.price) {
        stickyPrice.innerHTML = '<span class="price">' + bundle.price + '</span>';
      }

      applyStickyImage({ src: bundle.image, alt: bundle.imageAlt });
      syncStickyQuantity(
        bundle.quantity || 1,
        { min: bundle.quantity || 1, max: bundle.quantity || 1, step: 1 },
        true
      );

      if (stickyButton && !stickyButton.classList.contains('is-loading')) {
        var nativeButton = getNativeButton(productRoot, sectionId);
        var nativeUnavailable =
          !bundle.hasVariantSelectors &&
          nativeButton &&
          (nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true');

        stickyButton.disabled = Boolean(bundle.button.disabled || nativeUnavailable);
        stickyButton.textContent = stickyButton.dataset.defaultText || 'Add to cart';
      }
    }

    function syncFromNativeProduct() {
      var nativeButton = getNativeButton(productRoot, sectionId);
      var nativePrice = productRoot.querySelector('[id="price-' + sectionId + '"]');
      var variantText = getNativeVariantText(sectionId, productRoot);
      var nativeQuantityInput = getNativeQuantityInput(productRoot);

      if (nativeQuantityInput) nativeRules = getQuantityRules(nativeQuantityInput, nativeRules);

      var nativeQuantity = nativeQuantityInput
        ? normalizeQuantity(nativeQuantityInput.value, nativeRules)
        : normalizeQuantity(stickyQuantity ? stickyQuantity.value : nativeRules.min, nativeRules);

      if (stickyTitle && originalTitle) stickyTitle.textContent = originalTitle;

      if (stickyVariant) {
        stickyVariant.classList.toggle('hidden', !variantText);
        stickyVariant.textContent = variantText;
      }

      if (stickyPrice && nativePrice) stickyPrice.innerHTML = nativePrice.innerHTML;
      applyStickyImage(nativeImage);
      syncStickyQuantity(nativeQuantity, nativeRules, false);

      if (stickyButton && nativeButton && !stickyButton.classList.contains('is-loading')) {
        stickyButton.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
        stickyButton.textContent = stickyButton.dataset.defaultText || 'Add to cart';
      }
    }

    function syncSticky() {
      var bundle = getSelectedBundleInfo(productRoot);
      if (bundle) syncFromBundle(bundle);
      else syncFromNativeProduct();
    }

    function setVisibility(shouldShow) {
      if (visibilityState.visible === shouldShow) return;

      visibilityState.visible = shouldShow;
      bar.classList.toggle('is-visible', shouldShow);
      updateBodyVisibilityClass();

      if (shouldShow) window.requestAnimationFrame(syncSticky);
    }

    function updateVisibilityFromState() {
      setVisibility(visibilityState.passedThreshold && visibilityState.primaryActionAbove);
    }

    function initializeVisibility() {
      var primaryAction = getNativeButton(productRoot, sectionId);
      if (!primaryAction) return;

      if ('IntersectionObserver' in window) {
        visibilitySentinel = document.createElement('span');
        visibilitySentinel.setAttribute('aria-hidden', 'true');
        visibilitySentinel.style.cssText =
          'position:absolute;top:' +
          Math.max(0, showAfter) +
          'px;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
        document.body.appendChild(visibilitySentinel);

        visibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === visibilitySentinel) {
              visibilityState.passedThreshold = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            } else if (entry.target === primaryAction) {
              visibilityState.primaryActionAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            }
          });

          updateVisibilityFromState();
        });

        visibilityObserver.observe(visibilitySentinel);
        visibilityObserver.observe(primaryAction);
        return;
      }

      legacyVisibilityHandler = function () {
        var actionRect = primaryAction.getBoundingClientRect();
        visibilityState.passedThreshold = window.scrollY >= showAfter;
        visibilityState.primaryActionAbove = actionRect.bottom <= 0;
        updateVisibilityFromState();
      };

      window.addEventListener('scroll', legacyVisibilityHandler, { passive: true, signal: signal });
      window.addEventListener('resize', legacyVisibilityHandler, { signal: signal });
      legacyVisibilityHandler();
    }

    if (stickyMinus && stickyQuantity) {
      stickyMinus.addEventListener(
        'click',
        function () {
          if (stickyQuantity.readOnly) return;

          var rules = getQuantityRules(stickyQuantity, nativeRules);
          var nextQuantity = normalizeQuantity(getQuantity(stickyQuantity.value) - rules.step, rules, 'down');
          stickyQuantity.value = String(setNativeQuantity(productRoot, nextQuantity, rules, 'down'));
          syncStickyQuantity(stickyQuantity.value, rules, false);
        },
        { signal: signal }
      );
    }

    if (stickyPlus && stickyQuantity) {
      stickyPlus.addEventListener(
        'click',
        function () {
          if (stickyQuantity.readOnly) return;

          var rules = getQuantityRules(stickyQuantity, nativeRules);
          var nextQuantity = normalizeQuantity(getQuantity(stickyQuantity.value) + rules.step, rules, 'up');
          stickyQuantity.value = String(setNativeQuantity(productRoot, nextQuantity, rules, 'up'));
          syncStickyQuantity(stickyQuantity.value, rules, false);
        },
        { signal: signal }
      );
    }

    if (stickyQuantity) {
      stickyQuantity.addEventListener(
        'change',
        function () {
          if (stickyQuantity.readOnly) return;

          var rules = getQuantityRules(stickyQuantity, nativeRules);
          stickyQuantity.value = String(setNativeQuantity(productRoot, stickyQuantity.value, rules));
          syncStickyQuantity(stickyQuantity.value, rules, false);
        },
        { signal: signal }
      );
    }

    if (stickyButton) {
      stickyButton.addEventListener(
        'click',
        function () {
          if (stickyButton.disabled || stickyButton.classList.contains('is-loading')) return;

          var bundle = getSelectedBundleInfo(productRoot);
          if (!bundle && stickyQuantity) {
            var rules = getQuantityRules(stickyQuantity, nativeRules);
            stickyQuantity.value = String(setNativeQuantity(productRoot, stickyQuantity.value, rules));
          }

          if (
            window.PawlishProductCartCoordinator &&
            typeof window.PawlishProductCartCoordinator.submitForRoot === 'function'
          ) {
            window.PawlishProductCartCoordinator.submitForRoot(productRoot, stickyButton);
            return;
          }

          var fallbackButton = bundle ? bundle.button : getNativeButton(productRoot, sectionId);
          if (fallbackButton && !fallbackButton.disabled) fallbackButton.click();
        },
        { signal: signal }
      );
    }

    document.addEventListener(
      'change',
      function (event) {
        if (!event.target || !productRoot.contains(event.target)) return;

        var isVariantControl =
          event.target.matches &&
          event.target.matches(
            'variant-selects input[type="radio"], variant-selects select, variant-radios input[type="radio"], variant-radios select'
          );

        if (isVariantControl) {
          imageSyncToken += 1;
          updateNativeImage(getSelectedOptionImage(sectionId, productRoot), true);
        }

        if (
          event.target.matches &&
          event.target.matches(
            '.bqu-radio, .bqu-unit-variant-select, .bqu-variant-select, input[name="id"], select[name="id"], variant-selects select, variant-radios input, input[name="quantity"]'
          )
        ) {
          window.requestAnimationFrame(syncSticky);
        }
      },
      { signal: signal }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target || !productRoot.contains(event.target) || !event.target.closest) return;

        if (event.target.closest('.bqu-card, .bqu-card-top, variant-selects, variant-radios, quantity-input')) {
          window.requestAnimationFrame(syncSticky);
        }
      },
      { signal: signal }
    );

    productRoot.addEventListener(
      'pro:cart:add:end',
      function () {
        window.requestAnimationFrame(syncSticky);
      },
      { signal: signal }
    );

    productRoot.addEventListener(
      'pro:cart:add:error',
      function () {
        window.requestAnimationFrame(syncSticky);
      },
      { signal: signal }
    );

    if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
      unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data ? event.data : null;
        if (!data || String(data.sectionId || '') !== String(sectionId)) return;

        var token = ++imageSyncToken;
        var sourceState = getSourceStickyState(data.html, sectionId);
        var variantImage = getVariantFeaturedImage(data.variant);
        var sourceOptionImage = getSelectedOptionImage(sectionId, data.html);
        var liveOptionImage = getSelectedOptionImage(sectionId, productRoot);
        var resolvedImage;

        if (variantImage) {
          resolvedImage =
            (sourceState && sourceState.image && sourceState.image.src && sourceState.image) || variantImage;
        } else {
          resolvedImage =
            sourceOptionImage ||
            liveOptionImage ||
            (sourceState && sourceState.image && sourceState.image.src && sourceState.image) ||
            nativeImage;
        }

        updateNativeImage(resolvedImage, true);

        if (sourceState && sourceState.rules) nativeRules = sourceState.rules;

        syncSticky();

        if (!variantImage) {
          resyncNativeImageAfterVariant(data.variant && data.variant.id, token, 2);
        }
      });

      if (PUB_SUB_EVENTS.quantityUpdate) {
        unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
          window.requestAnimationFrame(syncSticky);
        });
      }
    }

    initializeVisibility();

    instances.set(bar, {
      destroy: function () {
        controller.abort();
        if (typeof unsubscribeVariant === 'function') unsubscribeVariant();
        if (typeof unsubscribeQuantity === 'function') unsubscribeQuantity();
        if (visibilityObserver) visibilityObserver.disconnect();
        if (visibilitySentinel) visibilitySentinel.remove();
        bar.classList.remove('is-visible');
      },
    });

    window.requestAnimationFrame(syncSticky);
  }

  function initProStickyAtc(scope) {
    getStickyBars(scope).forEach(initStickyBar);
  }

  var menuSelector = [
    'header-drawer details[open]',
    'menu-drawer details[open]',
    'details.menu-opening[open]',
    '.menu-drawer-container details[open]',
    '[data-mobile-menu] details[open]',
  ].join(',');

  function updateStickyAtcMenuState() {
    var stickyBar = document.querySelector('[data-pro-sticky-atc]');
    var bodySpace = parseInt((stickyBar && stickyBar.dataset.mobileBodySpace) || '94', 10);

    if (stickyBar) {
      document.documentElement.style.setProperty(
        '--pro-sticky-atc-mobile-body-space',
        (Number.isFinite(bodySpace) ? bodySpace : 94) + 'px'
      );
    } else {
      document.documentElement.style.removeProperty('--pro-sticky-atc-mobile-body-space');
    }

    document.body.classList.toggle(
      'pro-sticky-atc-menu-open',
      Boolean(stickyBar) &&
        window.matchMedia('(max-width: 749px)').matches &&
        Boolean(document.querySelector(menuSelector))
    );
  }

  function scheduleMenuUpdate() {
    window.requestAnimationFrame(updateStickyAtcMenuState);
  }

  document.addEventListener(
    'click',
    function () {
      window.setTimeout(scheduleMenuUpdate, 60);
    },
    true
  );
  document.addEventListener('keyup', scheduleMenuUpdate, true);
  document.addEventListener('toggle', scheduleMenuUpdate, true);

  var menuObserver = null;
  var observedHeader = null;

  function getHeaderObserverRoot() {
    return document.querySelector('#shopify-section-header') || document.querySelector('header') || document.body;
  }

  function rebindMenuObserver() {
    var nextHeader = getHeaderObserverRoot();
    if (menuObserver && observedHeader === nextHeader && nextHeader.isConnected) return;

    if (menuObserver) menuObserver.disconnect();

    observedHeader = nextHeader;
    menuObserver = new MutationObserver(scheduleMenuUpdate);
    menuObserver.observe(observedHeader, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class', 'aria-expanded'],
    });
  }

  rebindMenuObserver();

  var mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  if (typeof mobileMediaQuery.addEventListener === 'function') {
    mobileMediaQuery.addEventListener('change', scheduleMenuUpdate);
  } else if (typeof mobileMediaQuery.addListener === 'function') {
    mobileMediaQuery.addListener(scheduleMenuUpdate);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProStickyAtc(event.target);
    rebindMenuObserver();
    scheduleMenuUpdate();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
    window.requestAnimationFrame(function () {
      rebindMenuObserver();
      updateStickyAtcMenuState();
    });
  });

  window.PawlishStickyAtc = {
    init: initProStickyAtc,
    destroy: destroyWithin,
    refresh: function () {
      initProStickyAtc(document);
      rebindMenuObserver();
      updateBodyVisibilityClass();
      updateStickyAtcMenuState();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.PawlishStickyAtc.refresh();
    });
  } else {
    window.PawlishStickyAtc.refresh();
  }

  window.addEventListener('load', function () {
    window.PawlishStickyAtc.refresh();
  });
})();
